<template>
    <div id="resourceCommentList">
        <div class="second-header-wrap">
            <el-button type="default" @click="$router.back()" size="medium">返回</el-button>
            <el-button type="primary" @click="showCommentHandler()" v-if="fromType === 'user'" size="medium">评论</el-button>
        </div>
        <div class="main-container">
            <div class="main-introdution-wrap custom—scrollbar" :style="{height: mainContainerHeight}">
                <div class="inner-content-wrap">
                    <div class="main-container">
                        <ul class="comment-item-container">
                            <li class="comment-item" @click="showCommentHandler(commentItem.id, commentItem.replyUserId, commentItem.replyUser)" v-for="(commentItem, index) in commentList">
                                <div class="comment-item__avatar">
                                    <img :src="commentItem.replyAvatar">
                                </div>
                                <div class="comment-item__main">
                                    <div class="comment-item__author">
                                        <template v-if="commentItem.pid === null">
                                            {{commentItem.replyUser}}
                                        </template>
                                        <template v-else>
                                            {{commentItem.replyUser}} 回复 {{commentItem.receiverUser}}
                                        </template>
                                    </div>
                                    <div class="comment-item__content">{{commentItem.replyContent}}</div>
                                    <div @click.stop class="comment-item__photo-container"
                                         v-if="commentItem.replyImageJson && commentItem.replyImageJson !== '[]'">
                                        <image-previewer class="comment-item__photo" :images="commentItem.images" tag="span"> </image-previewer>
                                    </div>
                                </div>
                                <div class="comment-item__datetime">
                                    {{commentItem.replyTime | timeStampFilter }}
                                    <a v-if="commentItem.isTop === 1 && permission.indexOf('/videoResourcePlatform/videoResourcePlatformAdmin') !== -1" href="javascript:;" class="setTop" @click.stop="setTop(commentItem.id, 0)">取消置顶</a>
                                    <a v-if="commentItem.isTop === 0 && permission.indexOf('/videoResourcePlatform/videoResourcePlatformAdmin') !== -1" href="javascript:;" class="setTop" @click.stop="setTop(commentItem.id, 1)">置顶</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="pagination-container">
                    <el-pagination
                        @size-change="sizeChangeHandler"
                        @current-change="currentChangeHandler"
                        :current-page.sync="pagination.pageNo"
                        :page-sizes="[10 , 20, 30, 50]"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :page-count="pagination.pages"
                        :total="pagination.total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog
            title="评论"
            :visible.sync="isShowCommentDialog"
            width="40%"
        >
            <div class="image-container">
                <uploader
                    prefixPath="resourcePlatform"
                    v-model="files"
                    :multiple="true"
                    :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                    showMode="image"
                    showResult="image"
                >
                </uploader>
            </div>
            <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入评论"
                v-model.trim="replyContent"
                maxlength="200"
            >
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowCommentDialog = false">取 消</el-button>
                <el-button type="primary" :loading="isLoading" @click="commentHandler">确 定</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
    import Uploader from '@/components/Uploader/WebUploader';

    import {findMoralEduOLResourceReplyListByPage, addMoralEduOLResourceReply, commentTop} from '@/api/resourceManagement/resourceManagement';
    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer.vue';
    import moment from 'moment';
    import {mapGetters} from 'vuex';
    import baseMixin from '@/mixins/baseMixin.js';

    export default {
        name: "resourceCommentList",
        data() {
            return {
                files: [],

                isLoading: false,
                fromType: this.$route.query.fromType,

                currentReplyId: null,
                createUserId: this.$route.query.createUserId,
                resourceId: this.$route.query.resourceId,

                commentList: [],
                mainContainerHeight: 0,

                isShowCommentDialog: false,

                replyContent: '',
                previewImages: []
            }
        },
        components: {ImagePreviewer, Uploader},
        mixins: [baseMixin],
        created() {
            this.findMoralEduOLResourceReplyListByPageFunc();
        },
        mounted() {
            this.mainContainerHeight = `${window.innerHeight - 162}px`;
        },
        filters: {
            timeStampFilter(date) {
                return moment(date).format('YYYY-MM-DD');
            }
        },
        computed: {
            ...mapGetters(['userInfo', 'permission'])
        },
        methods: {
            setTop(id,num){
                commentTop({
                    isTop:num,
                    replyId:id
                }).then(res=>res.data)
                    .then(data=>{
                        if(data.code===200){
                            this.findMoralEduOLResourceReplyListByPageFunc();
                        }
                    })
            },
            showPreviewer(pics) {
                pics.forEach(item => item.src = item.photoUrl);
                if (pics && pics.length !== 0) {
                    this.previewImages = pics;
                    this.$refs.imagePreviewer.showPreviewer();
                }
            },
            commentHandler() {
                let args = {};

                const replyContent = this.replyContent;
                const replyImageJson = this.files;
                if(replyContent === '') {
                    this.$message({
                        message: '评论不能为空',
                        type: 'error'
                    });
                } else {
                    this.isLoading = true;
                    if(this.currentReplyId) {
                        args = {
                            moralType: 1001,
                            replyContent,
                            replyImageJson,
                            resourceId: this.resourceId,
                            pid: this.currentReplyId
                        }
                    } else {
                        args = {
                            moralType: 1001,
                            replyContent,
                            replyImageJson,
                            resourceId: this.resourceId
                        }
                    }
                    addMoralEduOLResourceReply(args)
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.isShowCommentDialog = false;

                                this.$message({
                                    message: '评论成功',
                                    type: 'success'
                                });
                                setTimeout(() => {
                                    this.findMoralEduOLResourceReplyListByPageFunc();
                                }, 300);
                            }
                        });
                }

            },
            showCommentHandler(pid, replyUserId) {
                if(this.userInfo.id !== replyUserId && this.fromType !== 'manage') {
                    this.replyContent = '';
                    this.images = [];
                    this.currentReplyId = pid;
                    this.isShowCommentDialog = true;
                }
            },
            sizeChangeHandler(pageSize) {
                this.pagination.pageSize = pageSize;
                this.pagination.pageNo = 1;
                this.findMoralEduOLResourceReplyListByPageFunc();
            },
            currentChangeHandler(pageNo) {
                this.pagination.pageNo = pageNo;
                this.findMoralEduOLResourceReplyListByPageFunc();
            },
            findMoralEduOLResourceReplyListByPageFunc() {
                findMoralEduOLResourceReplyListByPage({
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                    resourceId: this.resourceId,
                })
                    .then(res => res.data)
                    .then(data => {
                        data.data.dataList.forEach(item => {
                            const images = JSON.parse(item.replyImageJson);
                            images.forEach(image => image.src = image.photoUrl || image.fileUrl);
                            item.images = images;
                        });
                        this.commentList = data.data.dataList;
                        this.pagination.total = data.data.pagination.total;
                        this.isLoading = false;
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin.scss";

    @include reset-global;

    .second-header-wrap {
        position: fixed;
        top: 90px;
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        background-color: #fff;
        z-index: 1000;
    }

    .pagination-container {
        text-align: right;
        width: 1320px;
        margin: 10px auto 0 auto;
    }

    .inner-content-wrap::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .inner-content-wrap::-webkit-scrollbar-thumb {
        background-color: #999;
    }

    .inner-content-wrap::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }

    .main-container {
        margin-top: 162px;
    }

    .inner-content-wrap {
        margin-top: 80px;
        width: 100%;
        overflow-y: auto;
        height: 740px;
        .main-container {
            width: 1000px;
            margin: 0 auto;

            min-height: 560px;
        }
    }

    .image-item, .upload-hint {
        @include cover-bg;
        @include middleIB;
        @include wh(70px, 70px);
        margin-right: 5px;
    }
    .image-container {
        margin-bottom: 10px;
        .image-item {
            position: relative;
            .delete-file-btn {
                background-size: cover;
                width: 20px;
                height: 20px;
                position: absolute;
                right: 0;
                top: 0;
                background-image: url(https://cdnfile-10043692.file.myqcloud.com/admin/images/upload/close.png);
                display: block;
                float: right;
                cursor: pointer;
            }
        }
        .image-uploader {
            @include middleIB;
        }
    }

    .upload-hint {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        line-height: 70px;
        &:hover, &:focus {
            border-color: #409EFF;
            color: #409EFF;
        }
        font-size: 28px;
        color: #8c939d;
    }
    .comment-item {
        @include clearfix;
        position: relative;
        margin: 20px 0;
        .comment-item__avatar {
            img {
                border-radius: 50%;
                @include wh(50px, 50px);
            }
            float: left;
        }
        .comment-item__main {
            float: right;
            width: 900px;
        }
        .comment-item__author {
            margin-bottom: 10px;
        }
        .comment-item__content {
            width: 89%;
            word-break: break-all;
            font-size: 16px;
        }
        .comment-item__footer {
            color: #999;
            text-align: right;
        }
        .comment-item__datetime {
            position: absolute;
            right: 1px;
            top: 50%;
            transform: translateY(-50%);
        }
    }
</style>
<style lang="scss">
    @import "../../styles/mixin.scss";
    .comment-item__photo {
        .images {
            margin-right: 10px;
            width: 60px !important;
            height: 60px !important;
            display: inline-block !important;
            vertical-align: middle !important;
        }

    }
    #resourceCommentList {
        .file-name {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/resourceManagement/resourceCommentList.vue